// extracted by mini-css-extract-plugin
export default {"popupWindow":"modal_popupWindow__kTglM","popupWindow_type_wide":"modal_popupWindow_type_wide__cKO+Z","popupWindow__closeBtn":"modal_popupWindow__closeBtn__ezjY5"};